export default __webpack_public_path__ + "static/media/logo_Honestidad-Laboral.d79bb004.svg";